module.exports = __webpack_public_path__ + "static/media/square-white.76b09daf.svg";